import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  strokeWidth?: number;
}

const CloseIcon: FunctionComponent<Props> = ({
  className,
  width = 20,
  height = 19,
  fill = "currentColor",
  strokeWidth = 2,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Close</title>
      <line
        x1="1.70711"
        y1="0.831956"
        x2="18.6483"
        y2="17.7731"
        stroke={fill}
        strokeWidth={strokeWidth}
      />
      <line
        x1="1.35149"
        y1="17.7734"
        x2="18.2927"
        y2="0.832185"
        stroke={fill}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default CloseIcon;
